"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@material-ui/core");

var react_1 = __importDefault(require("react"));

require("./BB8AuthPanel.scss");

var BB8Button_1 = __importDefault(require("./BB8Button"));

var BB8AuthPanel = function BB8AuthPanel(_a) {
  var user = _a.user,
      logout = _a.logout;

  if (user) {
    return react_1.default.createElement("section", {
      className: "user-profile"
    }, react_1.default.createElement(core_1.Tooltip, {
      title: react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("p", null, react_1.default.createElement("small", null, "email: "), user.email), react_1.default.createElement("p", null, react_1.default.createElement("small", null, "role: "), user.role), react_1.default.createElement("p", null, react_1.default.createElement("small", null, "sub: "), user.sub))
    }, react_1.default.createElement("div", {
      className: "user"
    }, react_1.default.createElement("img", {
      className: "avatar",
      alt: "avatar",
      src: require("../assets/images/bb8-person_outline-24px.svg")
    }), react_1.default.createElement("span", {
      className: "user-name"
    }, user.username))), react_1.default.createElement("div", {
      className: "actions"
    }, react_1.default.createElement(BB8Button_1.default, {
      id: "bb8-btn-auth-signout",
      color: "primary",
      size: "small",
      onClick: logout
    }, "Signout")));
  } else {
    return react_1.default.createElement("section", {
      className: "user-profile"
    }, react_1.default.createElement("div", {
      className: "actions"
    }, react_1.default.createElement(BB8Button_1.default, {
      id: "bb8-btn-auth-signin",
      color: "primary",
      size: "small"
    }, "Signin")));
  }
};

exports.default = BB8AuthPanel;